if (!customElements.get("review-slider")) {
	customElements.define(
		"review-slider",
		class ReviewSlider extends HTMLElement {
			constructor() {
				super()

				this.slider = this.querySelectorAll(".review-slider__slides")

				if (this.slider[0]) {
					Array.from(this.slider).forEach((slider) => {
						this.initSlider(slider)
					})
				}
			}
			initSlider(slider) {
				let auto_height = slider.dataset.autoHeight == "true" ? true : false
				var review_slider = new Swiper(slider, {
					slidesPerView: 1,
					speed: 400,
					loop: true,
					loopFillGroupWithBlank: true,
					autoHeight: auto_height,
					spaceBetween: 0,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					breakpoints: {
						768: {
							spaceBetween: 30,
						},
					},
					mousewheel: {
						forceToAxis: true,
					},
				})
			}
		}
	)
}
